import { useNavigate, useParams } from "react-router";
import { RegisterReceptionForm } from "../components/register-reception";

/** Screen 016: register a reception of documents and/or maquettes. */
export function EnregistrerReception() {
  const { yardId } = useParams<{ yardId: string }>();
  const navigate = useNavigate();

  return (
    <RegisterReceptionForm
      onClose={() => navigate(`/yards/${yardId}`)}
      onSaved={() => navigate(`/yards/${yardId}/receptions`)}
    />
  );
}
